import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../utils/apiBase';
import { useAuth } from '../auth/AuthContext';

export default function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [mfaRequired, setMfaRequired] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { refreshAuth } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const res = await fetch(`${API_BASE}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, code: code || undefined }),
      });
      const data = await res.json();
      if (!res.ok) {
        if (data.error === 'MFA_REQUIRED') {
          setMfaRequired(true);
          setError('Two-factor code required.');
        } else {
          setError(data.error || 'Login failed');
        }
        return;
      }
      sessionStorage.setItem('id_token', data.token);
      sessionStorage.setItem('refresh_token', data.refreshToken);
      
      // Try to refresh auth, but navigate regardless to avoid getting stuck
      refreshAuth().finally(() => {
        navigate('/dashboard');
      });
    } catch (err) {
      console.error('login error', err);
      setError('Network or server error');
    }
  };

  return (
    <div style={{ maxWidth: 400, margin: '2rem auto' }}>
      <h2>Log In</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        {mfaRequired && (
          <div>
            <input
              type="text"
              placeholder="2FA code"
              value={code}
              onChange={e => setCode(e.target.value)}
              required
            />
          </div>
        )}
        <button type="submit">Log In</button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
}
